import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";

export const CaseStudyPager = ({ prev, next, current }) => (
  <div
    data-testid="case-study-pager"
    className="mt-4 grid gap-6 border-t border-white/10 pt-12 md:grid-cols-3 md:items-center"
  >
    <Link
      to={`/work/${prev.slug}`}
      data-testid="case-study-prev-link"
      className="group flex items-center gap-3"
    >
      <ArrowLeft className="h-5 w-5 shrink-0 text-[#8B5CF6] transition-transform duration-300 group-hover:-translate-x-1.5" />
      <span>
        <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-[#F4F6FB]/40">
          Previous
        </span>
        <span className="font-display mt-1 block text-base font-semibold text-[#F4F6FB] transition-colors duration-300 group-hover:text-[#8B5CF6] md:text-lg">
          {prev.title}
        </span>
      </span>
    </Link>

    <p className="text-center font-mono text-[10px] uppercase tracking-[0.3em] text-[#F4F6FB]/30">
      <span className="block text-[#D4AF37]/70">Current</span>
      <span data-testid="case-study-pager-current" className="mt-1 block text-[#F4F6FB]/60">
        {current.title}
      </span>
    </p>

    <Link
      to={`/work/${next.slug}`}
      data-testid="case-study-next-project-link"
      className="group flex items-center justify-end gap-3 text-right"
    >
      <span>
        <span className="block font-mono text-[10px] uppercase tracking-[0.3em] text-[#F4F6FB]/40">
          Next Project
        </span>
        <span className="font-display mt-1 block text-base font-semibold text-[#F4F6FB] transition-colors duration-300 group-hover:text-[#8B5CF6] md:text-lg">
          {next.title}
        </span>
      </span>
      <ArrowRight className="h-5 w-5 shrink-0 text-[#8B5CF6] transition-transform duration-300 group-hover:translate-x-1.5" />
    </Link>
  </div>
);

export default CaseStudyPager;
